export const data = [
  {
    no: 1,
    title: "공지사항",
    path: "/admin/service/notice",
  },
  {
    no: 2,
    title: "이벤트",
    path: "/admin/service/event",
  },
  {
    no: 3,
    title: "문의하기",
    path: "/admin/service/inquiry/1",
  },
  {
    no: 4,
    title: "자주하는 질문",
    path: "/admin/service/faq",
  },
  // {
  //   no: 5,
  //   title: "알림 발송",
  //   path: "/admin/service/push",
  // },
];
